import I18n from 'utils/I18n';

export const t = (key, params) =>
  I18n.t(`components.friends.${key}`, { ...params });

export default { t };
